<script setup>
import T from './SkyscraperIframe.i18n.js';
import CookieIframe from 'JIX/components/CookieIframe.vue';
import { ref } from 'vue';

defineProps({
    url: {
        type: String,
        required: true,
    },
    fallbackUrl: {
        type: String,
        required: false,
        default: null,
    },
    height: {
        type: Number,
        required: true,
    },
    width: {
        type: Number,
        required: true,
    },
});

const isJobindex = ref(window.Stash.common.site.startsWith('job'));

</script>

<template>
    <div class="jix_sidebar_skyscraper" :aria-label="T.annonce()">
        <div v-if="isJobindex" class="jix_sidebar_skyscraper_headline" role="heading">
            {{ T.annonce() }}
        </div>
        <CookieIframe
            :src="url"
            :fallback-src="fallbackUrl"
            :height="height"
            :width="width"
            required-consent-category="marketing"
            marginheight="0"
            marginwidth="0"
            scrolling="no"
            frameborder="0"
            autoload="lazy"
        />
    </div>
</template>
